import * as Sentry from '@sentry/browser';
import { store } from '../store.js';

class Logger {
	logInfo(message) {
		Sentry.withScope(function(scope) {
			scope.setUser({
				email: store.getters.user.data.email
			});
			scope.setLevel('info');
			Sentry.captureMessage(message);
		});
	}

	logError(type, error) {
		Sentry.withScope(function(scope) {
			scope.setUser({
				email: store.getters.user.data.email
			});
			scope.setContext('errorContext', {
				type: type,
				userId: store.getters.user.data.userId
			});
			scope.setLevel('error');
			Sentry.captureException(new Error(error));
		});
	}

	logWarning(type, error) {
		Sentry.withScope(function(scope) {
			scope.setUser({
				email: store.getters.user.data.email
			});
			scope.setContext('errorContext', {
				type: type,
				userId: store.getters.user.data.userId
			});
			scope.setLevel('warning');
			Sentry.captureException(new Error(error));
		});
	}
}

// Define as singleton
const instance = new Logger();
Object.freeze(instance);

export default instance;
